module.exports = __webpack_public_path__ + "static/media/brazilseedslogogrande.5b76f397.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brazilseedslogogrande.png
// module id = 26
// module chunks = 0